import _ from 'lodash';
import { textinputValidators } from './textinputValidators';
import { pageNameValidator, legacyPageNameValidator, pagesFolderNameValidator, } from './pageValidators';
import { menuItemNameValidator } from './menuValidators';
import { widgetNameValidator } from './widgetValidators';
import { validateAddress } from './googleMapsValidator';
import * as utils from './utils';
var validators = _.assign({}, textinputValidators, { pageNameValidator: pageNameValidator, legacyPageNameValidator: legacyPageNameValidator, pagesFolderNameValidator: pagesFolderNameValidator }, { menuItemNameValidator: menuItemNameValidator }, { widgetNameValidator: widgetNameValidator }, { validateAddress: validateAddress }, { utils: utils });
export default validators;
